import moment from 'moment';
// import momend from 'moment-timezone'

moment.locale('ko', {
  meridiem: (e) => {
    if (e >= 12) {
      return '오후';
    }
    return '오전';
  },
  weekdays: ['일', '월', '화', '수', '목', '금', '토'],
});

// moment.tz.setDefault("Asia/Seoul");

export default moment;
